import { render } from "./MessageWindow.vue?vue&type=template&id=2279d4e8&scoped=true"
import script from "./MessageWindow.vue?vue&type=script&lang=js"
export * from "./MessageWindow.vue?vue&type=script&lang=js"

import "./MessageWindow.vue?vue&type=style&index=0&id=2279d4e8&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2279d4e8"]])

export default __exports__